import queryString from 'query-string';
import { Dialog } from 'antd-mobile';
import { ReactNode } from 'react';

// 生成路径
export const genPath: (pathname: string, search?: { [key: string]: any }) => string = (pathname, search) => {
    const queryStr = search ? `?${queryString.stringify(search)}` : '';
    return `${pathname}${queryStr}`;
};

// 生成随机字符串
export function randomStringId() {
    let id = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    for (let i = 0; i < 4; i++) {
        id += characters.charAt(Math.floor(Math.random() * 26));
    }
    const timestamp = new Date().getTime().toString().slice(-4);
    return `${id}${timestamp}`;
}

// 生成随机字符串
export function randomNumberId() {
    const timestamp = new Date().getTime().toString().slice(-4);
    return +`${Math.random() * 1000}${timestamp}`;
}

// 将enum枚举转换为 [{label: '', value: ''}] 格式
export const convertEnumToArray: (enumType: any) => { label: string; value: string }[] = (enumType) => {
    const enumArray = [];

    // 遍历枚举键值
    for (const key in enumType) {
        // 排除数值键
        if (typeof enumType[key] === 'number') {
            // 添加 {label, value} 对象到数组
            enumArray.push({
                label: key,
                value: enumType[key].toString(), // 将数值转换为字符串
            });
        }
    }

    return enumArray;
};

// 打开确认弹窗
export const dialogConfirm: (args: {
    content?: ReactNode;
    showCancel?: boolean;
    title?: ReactNode;
    cancelText?: string;
    okText?: string;
}) => Promise<boolean | void> = ({ content, showCancel = true, title, cancelText = '取消', okText = '确定' }) => {
    if (showCancel) {
        return Dialog.confirm({
            title,
            content: <div className="pb-2 pt-3 text-center">{content}</div>,
            cancelText: <span className="text-base text-secondary">{cancelText}</span>,
            confirmText: <span className="text-base font-normal text-primary">{okText}</span>,
        });
    }
    return Dialog.alert({
        title,
        content: <div className="pb-2 pt-3 text-center">{content}</div>,
        confirmText: <span className="text-base font-normal text-primary">{okText}</span>,
    });
};
